export default class YouTubeManager {

    constructor() {

        this.loadYtIframeApi();
    }

    /*
     * Youtube API
     * https://developers.google.com/youtube/iframe_api_reference
     */

    loadYtIframeApi() {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';

        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
}
